import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 25 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M25 3.517A3.017 3.017 0 0 0 21.983.5H3.017A3.017 3.017 0 0 0 0 3.517v18.966A3.017 3.017 0 0 0 3.017 25.5h18.966A3.017 3.017 0 0 0 25 22.483V3.517Zm-2.586 0v11.638h-8.621V3.086h8.19a.43.43 0 0 1 .431.431Zm-19.4-.431h8.19v5.172H2.586V3.517a.431.431 0 0 1 .431-.431h-.003Zm-.431 19.4V10.845h8.621v12.069h-8.19a.43.43 0 0 1-.428-.431l-.003.003Zm19.4.431h-8.19v-5.176h8.621v4.741a.431.431 0 0 1-.431.432v.003Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }